export const FINDING_CHAT_DRAFT_KEY = "sa.findingChatDraft";
export const FINDING_FIX_TARGET_KEY = "sa.findingFixTarget";
export const MAIN_CHAT_SET_DRAFT_EVENT = "main-chat-set-draft";

export const XRAY_JOB_TYPE = {
  MODERNIZE: "XRAY_MODERNIZE",
  FIX: "XRAY_FIX",
  INIT: "XRAY_INIT"
};

export function formatFindingJsonMessage(finding) {
  if (!finding || typeof finding !== "object") return "";
  let json = "";
  try {
    json = JSON.stringify(finding, null, 2);
  } catch {
    json = "";
  }
  if (!json) return "Apply a fix for this Xray finding in the project.";
  return `Apply a fix for this Xray finding in the project. Use this finding JSON:\n\n${json}`;
}

export function formatFindingPrompt(finding) {
  if (!finding || typeof finding !== "object") return "";
  const loc = finding.location || finding.locations?.[0] || {};
  const start = loc.start || loc.region || {};
  const file =
    finding.file ||
    finding.path ||
    loc.file ||
    loc.path ||
    loc.uri ||
    "";
  const line =
    finding.line ||
    finding.line_number ||
    finding.start_line ||
    loc.line ||
    start.line ||
    "";
  const title = finding.title || finding.message || "Untitled finding";
  const severity = finding.severity || "unspecified";
  const rule = finding.rule_id || finding.rule || finding.category || "";
  const description = finding.description || finding.message || "";
  const evidence = Array.isArray(finding.evidence)
    ? finding.evidence
        .slice(0, 3)
        .map((item) => (typeof item === "string" ? item : item.message || item.snippet || ""))
        .filter(Boolean)
        .join("\n")
    : "";
  const fix = finding.remediation || finding.recommendation || "";

  return [
    "Please fix this Xray finding in the project.",
    "",
    `Severity: ${String(severity).toUpperCase()}`,
    `Title: ${title}`,
    file ? `File: ${file}${line ? `:${line}` : ""}` : "",
    rule ? `Rule: ${rule}` : "",
    "",
    description ? `What we found:\n${description}` : "",
    evidence ? `\nEvidence:\n${evidence}` : "",
    fix ? `\nSuggested remediation:\n${fix}` : "",
    "",
    "Open the related file in the code editor, apply a focused fix, and explain the change.",
  ]
    .filter((lineText, i, arr) => !(lineText === "" && arr[i - 1] === ""))
    .join("\n")
    .trim();
}

let heldFindingChatDraft = null;

export function saveFindingChatDraft(payload) {
  try {
    sessionStorage.setItem(FINDING_CHAT_DRAFT_KEY, JSON.stringify(payload || {}));
    return true;
  } catch {
    return false;
  }
}

/** Keep the handoff in memory as well as sessionStorage. Large modernize JSON can exceed the storage quota. */
export function stageFindingChatDraft(payload) {
  heldFindingChatDraft = payload || null;
  saveFindingChatDraft(payload);
  return heldFindingChatDraft;
}

export function clearFindingChatDraft() {
  heldFindingChatDraft = null;
  try {
    sessionStorage.removeItem(FINDING_CHAT_DRAFT_KEY);
  } catch {
    /* ignore */
  }
}

export function peekFindingChatDraft() {
  if (heldFindingChatDraft) return heldFindingChatDraft;
  try {
    const raw = sessionStorage.getItem(FINDING_CHAT_DRAFT_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function takeFindingChatDraft() {
  const draft = peekFindingChatDraft();
  clearFindingChatDraft();
  return draft;
}

export function saveFindingFixTarget(payload) {
  try {
    sessionStorage.setItem(FINDING_FIX_TARGET_KEY, JSON.stringify(payload || {}));
  } catch {
    /* ignore quota / private mode */
  }
}

export function peekFindingFixTarget() {
  try {
    const raw = sessionStorage.getItem(FINDING_FIX_TARGET_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearFindingFixTarget() {
  try {
    sessionStorage.removeItem(FINDING_FIX_TARGET_KEY);
  } catch {
    /* ignore */
  }
}

export function dispatchFindingChatDraft(text) {
  if (!text) return;
  window.dispatchEvent(new CustomEvent(MAIN_CHAT_SET_DRAFT_EVENT, { detail: { text } }));
}
